import { Trans } from '@lingui/react/macro';
import { NoddiIcon } from 'noddi-ui-common';

/** Opens the why sheet from inside a status card: a tinted row, as in Claude Design "Tire Offer". */
export const ReadWhyButton = ({ onClick }: { onClick: () => void }) => (
  <button
    type='button'
    onClick={onClick}
    className='flex w-full items-center gap-2.5 rounded-lg bg-lightPurple px-3.5 py-3 text-left text-sm font-semibold text-primary'
  >
    <NoddiIcon name='Info' size='small' />
    <span className='flex-1'>
      <Trans>Read more about why</Trans>
    </span>
    <NoddiIcon name='ChevronRight' size='small' />
  </button>
);
